import { Component, Input } from '@angular/core';
import { IJobsAndCareersCard } from 'src/app/interfaces/strapi';
import { NgFor, NgClass } from '@angular/common';
import { AuthService } from '../../../../services/auth.service';
import { AnalyticsService } from '../../../../services/analytics.service';

enum JobsAndCareersCardEnum {
  TOPFULL = 'top_full_width',
  BOTTOMFULL = 'bottom_full_width',
}

@Component({
    selector: 'app-jobs-and-careers-card',
    templateUrl: './jobs-and-careers-card.component.html',
    styleUrls: ['./jobs-and-careers-card.component.scss'],
    imports: [NgFor, NgClass],
})
export class JobsAndCareersCardComponent {
  public JobsAndCareersCardEnum = JobsAndCareersCardEnum;

  @Input() public cards: IJobsAndCareersCard[] = <IJobsAndCareersCard[]>[];

  constructor(
    private readonly auth: AuthService,
    private readonly analyticsService: AnalyticsService
  ) {}

  public navigate(url: string, title: string): void {
    const name = `jobs_careers_${title.replaceAll(' ', '_')}`.slice(0, 39);
    this.analyticsService.trackEvent(name, {
      source: 'WEB',
      universityUUID: this.auth.currentUser?.university.cmsId,
    });
    window.location.href = url;
  }
}
